<template>
    <v-dialog v-model="dialogSelectMeasureColor" max-width="400" :lazy="true" persistent>
        <v-card>
            <v-card-title class="headline">{{ $t('measure-color-selection') }}</v-card-title>

            <v-card-text>
                <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                        <v-flex v-for="color in colorsList" :key="color" xs2>
                            <v-btn :color="color" class="color-container" @click="selectColor(color)"></v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click.native="dialogSelectMeasureColor = false">{{ $t('cancel') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import MeasureModel from '@/models/Measure';

export default {
    name:  'measure-color-dialog',
    data:  function()
    {
        return {
            dialogSelectMeasureColor: false,
        };
    },
    computed: {
        colorsList: function()
        {
            return MeasureModel.getColorsList();
        },
    },
    methods: {
        /**
         * Ouverture de la boîte de dialogue
         *
         * @author Fabien Bellanger
         */
        open: function()
        {
            this.dialogSelectMeasureColor = true;
        },
        /**
         * Sélection d'une couleur
         *
         * @author Fabien Bellanger
         * @param {String} color Couleur
         */
        selectColor: function(color)
        {
            this.$emit('selectColor', color);

            this.dialogSelectMeasureColor = false;
        },
    },
};
</script>

<style scoped lang="scss">
    .v-btn {
        margin: 0px;
        min-width: 50px;
    }

    .color-container {
        height: 50px;
        cursor: pointer;
    }
</style>
